module.exports = __webpack_public_path__ + "img/3-3-coors-light-landing.7d3c7e35.jpg";